import React from "react";
import { connect } from "react-redux";
import { linkColorAccessible } from "../../../common/accessibleColors";
import "../../../common/tabComponents/TabComponents.scss";
import { Row, Col, Container } from "react-bootstrap";
import { submit, stopSubmit, touch } from 'redux-form';
import Header from "../../../common/header/Header";
import "../DataEntryDetails.scss";
import DataEntryDetailsLeftPane from "./DataEntryDetailsLeftPane";
import DataEntryDetailsRightPane from "./DataEntryDetailsRightPane";
import DataEntryDetailsBody from "./DataEntryDetailsBody";
import { tabItems } from "../DataEntryTabConstants";
import {
    onChangeDataEntryTab,
    getTransactionAttributesActionCreator,
    getFeeScheduleData,
    getTransactionNotesRequest,
    getAdditionalChargeType,
    getAdditionalChargeRecordsCreator,
    getTransactionDocuments,
    getRejectOptions,
    getShippingServicesData,
    getReleaseMethodOptionsData,
    getTransactionNoteTypes,
    uploadMultipleDocumentsActionCreator,
    getDocumentByIdActionCreator,
    resetDataEntryState,
    updateDocumentActionCreator,
    getDoucmentSourcesActionCreator,
    deleteDocumentActionCreator,
    getRetrieveProtocolActionCreator,
    getCancellationReasons,
    getSelectedPHICodesActionCreator,
    getPHICodesRequest,
    getUserGroupsActionCreator,
    getDisclosureReasonActionCreator,
    updateFormSyncErrorsActionCreator,
    getUserTasksActionCreator,
    getRequestTypesAndPurposesRequest,
    getFacilityDiscloseInstitutionsRequest,
    requestorVerificationEmailSent,
    RequestorVerificationEmailSentReset,
    setLastUsedRequestorInfo,
    requestorCompleteActionCreator,
    billingCompleteActionCreator,
    getFacilityAdditionalFieldsActionCreator,
    getWaitAndHoldReasons,
    getQAErrorsActionCreator,
    getQAIssuesActionCreator,
    getQAPDIssuesActionCreator,
    updateBillingPaneFields,
    getAssessmentResultsActionCreator,
    getAIFeedbackActionCreator,
    getReviewEntitiesActionCreator,
    getAuditUsersActionCreator,
    getCertificationTypesAction,
    setPDFPageNumberActionCreator,
    setCurrentFileTypeActionCreator,
    getSensitivityTypesActionCreator,
    getFacilityConfigurationsActionCreator,
    updateInformationToReleaseActionCreator,
    updateSensitiveInfoActionCreator,
} from "../DataEntryDetailsDucks";
import { getIntakeIntelligenceActionCreator } from "../IntakeDucks";
import {
  getOutboundTemplateRequest,
  getNextQATransaction
} from "../../landingPage/LandingPageDucks";
import { getRoutePathName } from "../../landingPage/LandingPage";
import { reset } from 'redux-form';
import { FormConstants } from "./DataEntryFieldsConstants";
import localValidations, { ignoreFields, infoToReleaseValidiation } from './validations/localValidations';
import { postCancellationReasonsActionCreators } from "../DataEntryDetailsDucks";
import LoadingSpinner from "../../../common/loadingSpinner/loadingSpinner";
import toast, { Toaster } from "react-hot-toast";
import TransactionDocument, { DocumentUploadRequest } from "../../../models/document";
import FeeSchedule from "../../../models/feeSchedule";
import { DISCLOSURE_ACCOUNTING, DISABILITY_OR_SOCIAL_SECURITY } from "../../../models/requestType";
import { SensitiveInfoRelease, SensitiveInfoType, TransactionDetails, ReleaseInfoUpdate, SensitiveInfoUpdateAPI, Release } from "../../../models/transaction";
import { Requestor } from "../../../models/requestor";
import { DropdownOption } from "../../../common/formFields/DropdownField";
import TransactionIssue, { QaError } from "../../../models/transactionIssue";
import { AssessmentResult, DRUG, EntityTypeId, HIV, HPV, PSYC_MHLT, ReviewEntity, STD } from "../../../models/assessment";
import { Address, AdministrationLevel, NameIdPair } from "../../../models/misc";
import AuditData from "../../../models/auditData";
import { RootState } from "typesafe-actions";
import { FeatureFlags, getQAFeatureFlagsRequest as getQAFeatureFlagsRequestActionCreator } from "../../login/LoginPageDucks";
import { RequestAnalysis, FieldGroupRow, FieldGroupRowStatus, isFieldGroupRowOutstanding, FieldGrounding } from "../../../models/intake";
import FacilityConfiguration from "../../../models/facilityConfiguration";
import QuickEntryFieldGroupList from "./QuickEntryFieldGroupList";
import QuickEntryFieldConfidence from "./QuickEntryFieldConfidence";
import QuickEntryActionFooter from "./QuickEntryActionFooter";
import RequestTypePurposeField, { mapRequestTypePurposeToFieldGroupRow, REQUEST_TYPE_PURPOSE_ROW_ID } from "./RequestTypePurposeField";
import AuthorizationDateField, { mapAuthorizationDateToFieldGroupRow, AUTHORIZATION_DATE_ROW_ID } from "./AuthorizationDateField";
import RequestDateField, { mapRequestDateToFieldGroupRow, REQUEST_DATE_ROW_ID } from "./RequestDateField";
import CaseNumberField, { mapCaseNumberToFieldGroupRow, CASE_NUMBER_ROW_ID } from "./CaseNumberField";
import ClinicResponsibleField, { mapClinicResponsibleToFieldGroupRow, CLINIC_RESPONSIBLE_ROW_ID } from "./ClinicResponsibleField";
import {
    mapRecordsRequestedToFieldGroupRow, RECORDS_REQUESTED_ROW_ID,
    mapServiceDateFromToFieldGroupRow, SERVICE_DATE_FROM_ROW_ID,
    mapServiceDateToToFieldGroupRow, SERVICE_DATE_TO_ROW_ID,
    getReleaseDateRange, buildReleaseInfoWithItemToggle, buildReleaseInfoWithDateRange,
} from "./RecordsRequestedField";
import SensitiveInfoField, { mapSensitiveInfoToFieldGroupRow, SENSITIVE_INFO_ROW_ID } from "./SensitiveInfoField";
import { RequestType } from "../../../models/requestType";
import DateField from "../../../common/formFields/DateField";
import { CheckboxList, Item as CheckboxItem } from "../../../common/formFields/CheckboxList";
import { DEFAULT_MIN_DATE } from "../../../common/constants/ApiConstants";

// No LowConfidence-row verification tracking is wired in F1a yet (its one
// row is always NeedsEntry/Confirmed, never LowConfidence) - a stable empty
// set is enough until a sibling Spec needs to thread real verified ids
// through.
const EMPTY_VERIFIED_ROW_IDS: ReadonlySet<string> = new Set();

export interface HealthSystemCounts {
  "total": number,
  "dataEntry": number,
  "recordAttachment": number,
  "recordValidation": number,
  "userTasks": number,
  "qaReview": number,
  "facilityActionRequired": number
}

export interface FacilitiesCountsModal {
  facility: NameIdPair<number>,
  transactionCounts: HealthSystemCounts,
}

export interface Facility {
  id: number,
  name: string,
  userTaskCounts?: HealthSystemCounts,
  billingStates: readonly AdministrationLevel[],
  useClinics: boolean,
  useDepartments: boolean,
  useRequestID: boolean,
  useEMPI: boolean,
  prohibitTraining: boolean,
  qaExcluded: boolean,
  address: Address,
}

export interface HealthSystemModal {
  id: number,
  name: string,
  facilities: FacilitiesCountsModal[],
}

export interface OrganizationDetailsModal {
  healthSystem: HealthSystemModal,
  transactionCounts: HealthSystemCounts,
  facilityCounts: FacilitiesCountsModal[],
}


interface Props {
  onChangeDataEntryTab: Function;
  activeTabId: number;
  proceedBtnClick: false;
  selectedHealthOrganizationDetails: OrganizationDetailsModal,
  selectedFacilityDetails: FacilitiesCountsModal,
  resetForm: Function,
  transactionId: string,
  getRequestsAndPurposes: Function,
  purposeOfRequests: any,
  transactionIDAttributes: any,
  getTransactionAttributes: Function,
  assignTransactionID: Function,
  resetDataEntryState: Function,
  /** RecordsRequestedField's save callback (Spec #34098 / F1a) - same action the classic pane already dispatches. */
  saveInformationToRelease: (data: ReleaseInfoUpdate) => void,
  /** SensitiveInfoField's save callback (Spec #34098 / F1a) - same action the classic pane already dispatches. */
  saveAndUpdateSensitiveInfo: (data: SensitiveInfoUpdateAPI) => void,
  patientDetails?: any,
  transactionDetails?: TransactionDetails,
  getFacilityFeeSchedules: (organizationId: number, transactionId: string) => void,
  getTransactionNotesRequest: Function,
  transactionNotes: any,
  getAdditionalChargeType: Function,
  getAdditionalChargeRecords: Function,
  getTransactionDocuments: Function,
  documentsList: readonly TransactionDocument[],
  getRejectOptions: Function,
  getFacilityShippingServices: Function,
  getFacilityReleaseMethods: (facilityId: number, transactionId: string) => void,
  getTransactionNoteTypes: Function,
  uploadMultipleDocuments: (request: DocumentUploadRequest) => void,
  getDocumentById: (documentId: string) => void,
  updateDocument: (data: any) => void,
  getDocumentSources: Function,
  documentSources: DropdownOption[],
  getRejectionLetter: Function,
  getEntityTypes: () => void,
  getAIFeedback: () => void,
  getAssessmentResults: (transactionId: string) => void,
  assessmentResult?: AssessmentResult,
  getReviewEntities: (transactionId: string) => void,
  deleteDocument: (documentId: string) => void,
  deleteAuxDocument: (documentId: string) => void,
  deleteDocumentSuccess?: boolean,
  getRetrieveProtocol: Function,
  retrieveProtocol: any,
  transactionCancellationReasons: Function,
  formState: any,
  /** Options source for the shared ClinicResponsibleField (Spec #34098 / F1a) - same state.dataEntryState.discloseInstitutions the classic RightPane already reads. */
  discloseInstitutions?: any,
  getSelectedPHICodes: Function,
  getPHICodesRequest: any,
  getUserGroups: (organizationId: number) => void,
  getDisclosureReasons: Function,
  submitForm: Function,
  stopSubmit: Function,
  updateFormSyncErrors: Function,
  getUserTasks: Function,
  userTasks: any,
  userTaskComments: any,
  touch: Function,
  getFacilityDiscloseInstitutionsRequest: Function,
  feeSchedules?: FeeSchedule[],
  history: any,
  logoutUser: Function,
  userState: any,
  additionalChargeRecords: any,
  isRequestorVerificationEmailSent: boolean,
  requestorVerificationEmailPopupTriggered: boolean,
  requestorVerificationEmailSentReset: Function,
  requestorVerificationEmailSent: Function,
  setLastUsedRequestorInfo: any,
  requestorDetails?: Requestor,
  patchRequestorComplete?: Function,
  patchBillingComplete?: Function,
  postCancellationReasonsDispatch?: any
  intiaTxlSagaCallCount: number,
  getFacilityAdditionalFieldsActionCreator?: Function,
  transactionWaitAndHoldReasons: Function,
  requestContext: any,
  getOutboundTemplateRequest?: Function,
  uploadDocumentSuccess: any,
  getQAErrors: () => void,
  qaErrors: QaError[],
  getQAIssues: (transactionId: string) => Promise<void>,
  QAIssues: TransactionIssue[],
  /**
   * Fires the QA PD Issues fetch on mount so the Redux store is populated for
   * DataEntryDetailsRightPane's own Redux-connected read of the same slice
   * (RightPane has its own mapStateToProps/mapDispatchToProps for this data -
   * see DataEntryDetailsRightPane.tsx). The resulting value is not consumed
   * here, so unlike QAIssues above there is no corresponding value prop.
   */
  getQAPDIssues: (transactionId: string) => Promise<void>,
  updateBillingPaneFields?:Function,
  getNextQATransaction: Function,
  getAuditUsers?: Function,
  getCertificationTypes: Function,
  featureFlags: FeatureFlags,
  getTransactionDocumentsAPIStatus: any;
  setPageNumber: Function,
  pageNumber: number,
  currentFile: string,
  setCurrentFileType: Function,
  currentFileType?: string,
  auditTrail?: Array<AuditData>,
  getFacilityConfiguration: Function,
  getIntakeIntelligence: (organizationId: number, requestBufferId: number) => void,
  requestAnalysis?: RequestAnalysis,
  /**
   * Per-facility DB toggle (Tech Lead note, AB#34098): the SAME gate
   * DataEntryDetailsBody.tsx already checks (`facilityConfiguration
   * .intakeIntelligenceEnabled`) to show/hide the classic Extract button.
   * Quick Entry must require it too - a facility with IntakeIntelligence
   * on globally but this toggle off must never become Quick-Entry-eligible.
   */
  facilityConfiguration?: FacilityConfiguration,
  /**
   * Classic-Mode-exit override (owned/authored by F1d #34102 - F1a only
   * reads it). Defaults to false until F1d lands the real exit dialog.
   */
  classicModeOverride?: boolean,
  healthSystemDataEntryCount?: number,
  getQAFeatureFlagsRequest: Function,
  /**
   * AC11 (F1a): needed to mount the shared RequestTypePurposeField inside
   * the Quick Entry row - mirrors DataEntryDetailsRightPane's own
   * `requestTypes: state.dataEntryState.requestTypes` binding.
   */
  requestTypes?: readonly RequestType[],
  /**
   * AC11 (F1a): raw dispatch, needed because RequestTypePurposeField's
   * contract takes `dispatch: Function` directly (it calls writeFieldToForm
   * itself) rather than a pre-bound action creator.
   */
  dispatch?: Function,
}

interface State {
  test: string;
  active: boolean[];
  tabClick: boolean,
  showLoadingSpinner: boolean,
  showRequestorPopUp: boolean,
  hasUserMadeAnyChanges: boolean,
  /**
   * Quick Entry only: row ids the specialist has explicitly clicked "Edit"
   * on. A Confirmed row shows its plain value + an Edit affordance by
   * default (master-demo-v6.html's row anatomy) and only shows the live
   * editable control while its id is in this set or its status isn't
   * Confirmed yet. Classic mode's shared field components stay always-
   * editable (unaffected) - this toggle is purely a Quick Entry list
   * behavior layered on top in renderQuickEntryRowContent.
   */
  quickEntryEditingRowIds: ReadonlySet<string>,
  /**
   * Quick Entry only: optimistic local override of transactionDetails.
   * releaseInfo. Split into 3 independent rows (Service Date-From, Service
   * Date-To, Records Requested per master-demo-v6.html), each mounted as
   * its own top-level component in renderQuickEntryRowContent's switch -
   * they aren't siblings within one component's JSX, so the shared
   * checked-items/date-range view has to live here rather than in any one
   * row's own local state (same reasoning as quickEntryEditingRowIds).
   * null = not yet touched this transaction, derive straight from props.
   */
  quickEntryReleaseInfo: readonly Release[] | null,
  quickEntryReleaseComments: string | null,
  /**
   * Quick Entry only: scratch From/To/AllDates the specialist is actively
   * typing, tracked SEPARATELY from quickEntryReleaseInfo's own Release[]
   * items. Release.dateOfService requires both from AND to together (see
   * models/transaction.ts's DateRange), so a half-entered range (From set,
   * To not yet) has nowhere valid to live in that array - deriving the
   * DateField's displayed value back from releaseInfo caused the field to
   * revert to empty on every render (direct user report). Classic mode's
   * InfoToRelease.tsx avoids this the same way: fromDate/toDate live in
   * their own useState, independent of the Release[] representation, which
   * is only ever built (via buildReleaseInfoWithDateRange) once a complete
   * range is ready to persist/validate. null = not yet touched this
   * transaction, derive from getReleaseDateRange(releaseInfo) instead.
   */
  quickEntryServiceDateOverride: { from?: Date; to?: Date; allDates: boolean } | null,
}

interface tabItemModal {
  id: number,
  label: string
}

class DataEntryDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.props.resetForm()
    this.props.onChangeDataEntryTab(1, false)
  }
  state: State = {
    test: "",
    active: [false, false, false, false],
    tabClick: false,
    showLoadingSpinner: false,
    showRequestorPopUp: false,
    hasUserMadeAnyChanges: false,
    quickEntryEditingRowIds: new Set(),
    quickEntryReleaseInfo: null,
    quickEntryReleaseComments: null,
    quickEntryServiceDateOverride: null,
  };

  componentDidMount() {
    if(global.userID === undefined){
      const id = sessionStorage.getItem("userID");
      global.userID = id ? Number(id) : 0;
    }
    this.setState({ showLoadingSpinner: true })
    if(this.props.requestContext == 3 || this.props.requestContext == 4){
      this.props.onChangeDataEntryTab(4, true)
      const id: number = 4;
      this.handleSelectedTab(4 - 1);
    }else{
      const id: number = this.props.activeTabId;
      this.handleSelectedTab(id - 1);
    }

    this.initialAPICalls(this.props.transactionId)
    this.setState({ showLoadingSpinner: false });
  }

  savePanelSizes = () => {
    const leftPanel = document.getElementById("leftPanel");
    const centerPanel = document.getElementById("centerPanel");
    if (leftPanel != null) {
      localStorage.setItem("leftWidth", leftPanel.offsetWidth + "px");
    }
    if (centerPanel != null) {
      localStorage.setItem("centerWidth", centerPanel.offsetWidth + "px");
    }
  }

  componentWillUnmount = () => {
    this.props.onChangeDataEntryTab(1, false)
    this.props.resetForm()
    this.props.resetDataEntryState()
    this.savePanelSizes();
  }

  renderTabItems = () => {
    return (
      <div className="breadcrumDiv">
        <ul className="steps">
          {tabItems.map((item: tabItemModal, index: number) => {
            return this.state.active[index] ? (
              <li className="activeSelection"
                id={index.toString()}
                key={index}
                onClick={() => this.handleClick(item)}
              >
                <a href="#!" style={{ color: linkColorAccessible }}>{item.label}</a>
              </li>
            ) : (
              <li id={index.toString()} key={index} onClick={() => this.handleClick(item)}
                className={(this.props.transactionDetails?.requestPurpose?.typeID == DISCLOSURE_ACCOUNTING && (item.id === 3 || item.id === 4)) || (item.id > this.props.activeTabId + 1  && this.props.activeTabId != 2) ? 'disabled-tab' : ''} >
                <a href="#!" className={(this.props.transactionDetails?.requestPurpose?.typeID == DISCLOSURE_ACCOUNTING && (item.id === 3 || item.id === 4)) || (item.id > this.props.activeTabId + 1 && this.props.activeTabId != 2)? 'disabled-tab-a' : ''}>{item.label}</a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  /**
   * AC19: Quick Entry's step-tabs nav replaces the classic breadcrumb
   * (renderTabItems) above the center/right split. "Request Info" is the
   * only functional step in F1a's scope (it's the sole pane rendered);
   * Billing/Records render as disabled placeholders reserving the mockup's
   * layout until F1d (#34102) implements the Billing pane transition and a
   * later slice implements Records.
   */
  renderQuickEntryStepTabs = () => {
    return (
      <nav className="step-tabs" aria-label="Request sections">
        <button type="button" className="step-tab is-active" aria-current="step">Request Info</button>
        <button type="button" className="step-tab step-tab--disabled" disabled title="Available after Confirm All">Billing</button>
        <button type="button" className="step-tab step-tab--disabled" disabled title="Available after the transaction is created">Records</button>
      </nav>
    );
  };

  handleSelectedTab = (selectedId: number) => {
    let active = this.state.active;
    active.forEach((element, inx) => {
      return selectedId === inx ? (active[inx] = true) : (active[inx] = false);
    });
    this.setState({ active: active });
  };
  handleNavigation = () => {
    this.setState({ tabClick: false });
    const id: number = this.props.activeTabId;
    this.handleSelectedTab(id - 1);
  };
  handleClick = (tabItem: tabItemModal) => {
    const values = this.props.formState?.values || { values: {} }
    sessionStorage.setItem("formValues", JSON.stringify(values))
      document.getElementsByClassName('right-pane')[0].scrollTo(0,0)
    if (tabItem.id < this.props.activeTabId) {
      this.setState({ tabClick: true })
      this.props.onChangeDataEntryTab(tabItem.id, true)
      this.handleSelectedTab(tabItem.id - 1)
      return null
    }

    if(this.props.activeTabId + 1 < tabItem.id){
      return null;
    }

    if (this.props.activeTabId === 1) {
      this.props.getFacilityFeeSchedules(this.props.transactionDetails!.facility.id, this.props.transactionId)
      this.props.getFacilityShippingServices(this.props.transactionDetails!.facility.id);
      this.props.getFacilityReleaseMethods(this.props.transactionDetails!.facility.id, this.props.transactionId);
    } else if (this.props.activeTabId === 2) {
      this.props.setLastUsedRequestorInfo({
        requestorName: this.props.requestorDetails?.fullName,
        address1: this.props.requestorDetails?.requestorAddress.address1,
        address2: this.props.requestorDetails?.requestorAddress.address2,
        city: this.props.requestorDetails?.requestorAddress.city,
        state: this.props.requestorDetails?.requestorAddress.state,
        zip: this.props.requestorDetails?.requestorAddress.zipCode,
        firstName: this.props.requestorDetails?.requestorInfo?.firstName,
        lastName: this.props.requestorDetails?.requestorInfo?.lastName,
        email: this.props.requestorDetails?.requestorInfo?.email,
        phone: this.props.requestorDetails?.requestorInfo?.phone,
        fax: this.props.requestorDetails?.requestorInfo?.fax,
        requestorContactId: this.props.requestorDetails?.requestorInfo?.id,
        requestorId: this.props.requestorDetails?.requestorID,
        requestPurpose: this.props.transactionDetails?.requestPurpose,
        org: this.props.selectedFacilityDetails.facility.id,
        transactionId: this.props.transactionId
      });
      this.props.patchRequestorComplete && this.props.patchRequestorComplete(this.props.transactionId);
      this.props.getTransactionAttributes && this.props.getTransactionAttributes(this.props.transactionId); //if this is only being done to refresh the status, please delete
    }else if (this.props.activeTabId === 3) {

      this.props.patchBillingComplete && this.props.patchBillingComplete(this.props.transactionId);
    }

    if (this.props.activeTabId != 2 || this.props.transactionDetails?.requestPurpose?.typeID != DISCLOSURE_ACCOUNTING) {
      this.props.submitForm()
    }
    let validations = localValidations(values, { activeTabId: this.props.activeTabId, transactionDetails: this.props.transactionDetails, feeSchedules: this.props.feeSchedules })
    ignoreFields.map(item => delete validations[item])
    this.props.stopSubmit(validations)
    const fieldErrorsCount = Object.keys(validations).length
    this.props.updateFormSyncErrors(validations)
    if (!fieldErrorsCount && this.props.transactionDetails?.requestPurpose?.typeID != DISCLOSURE_ACCOUNTING) {
      this.setState({ tabClick: true });
      this.props.onChangeDataEntryTab(tabItem.id, true);
      this.handleSelectedTab(tabItem.id - 1);
    }
    else if (!fieldErrorsCount && this.props.transactionDetails?.requestPurpose?.typeID == DISCLOSURE_ACCOUNTING && (tabItem.id !== 3 && tabItem.id !== 4)) {
      this.setState({ tabClick: true });
      this.props.onChangeDataEntryTab(tabItem.id, true);
      this.handleSelectedTab(tabItem.id - 1);
    }
  };

  initialAPICalls = (transactionId: string) => {
    if (transactionId && this.props.selectedFacilityDetails && global.userID) {
      const organizationId = parseInt(transactionId.split("-")[0]);
      const requestBufferId = parseInt(transactionId.split("-")[1]);
      this.props.getFacilityAdditionalFieldsActionCreator?.(organizationId);
      this.props.getTransactionAttributes(this.props.transactionId);
      this.props.getFacilityFeeSchedules(organizationId, this.props.transactionId)
      this.props.getTransactionNotesRequest(this.props.transactionId)
      this.props.getRetrieveProtocol(this.props.transactionId)
      this.props.getAdditionalChargeType(organizationId)
      this.props.getRejectOptions(organizationId)
      this.props.getTransactionNoteTypes(organizationId)
      this.props.getDocumentSources(organizationId)
      this.props.getAdditionalChargeRecords(this.props.transactionId)
      this.props.getTransactionDocuments(this.props.transactionId)
      this.props.getFacilityShippingServices(organizationId)
      this.props.getFacilityReleaseMethods(organizationId, this.props.transactionId)
      this.props.getPHICodesRequest(organizationId)
      this.props.transactionCancellationReasons(organizationId)
      this.props.getSelectedPHICodes(this.props.transactionId)
      this.props.getUserGroups(organizationId)
      this.props.getDisclosureReasons(organizationId)
      this.props.getUserTasks(this.props.transactionId)
      if (this.props.featureFlags.FinalQAAccordions) {
        this.props.getEntityTypes();
        this.props.getReviewEntities(this.props.transactionId)
        this.props.getAssessmentResults(this.props.transactionId)
        this.props.getAIFeedback()
      }
      if (this.props.featureFlags.IntakeIntelligence) {
        this.props.getIntakeIntelligence(organizationId, requestBufferId);
      }
      this.props.getRequestsAndPurposes(organizationId)
      this.props.getQAErrors()
      this.props.getQAIssues(this.props.transactionId)
      this.props.getQAPDIssues(this.props.transactionId)
      this.props.getOutboundTemplateRequest && this.props.getOutboundTemplateRequest()
      this.props.getAuditUsers?.(this.props.transactionId);
      if (this.props.featureFlags.AutoCertification) {
        this.props.getCertificationTypes();
      }
      this.props.getFacilityConfiguration(organizationId);
      this.props.getQAFeatureFlagsRequest();

      this.setState({ hasUserMadeAnyChanges: false })
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.intiaTxlSagaCallCount >= 18 && this.state.showLoadingSpinner) {
      this.setState({ showLoadingSpinner: false })
    }

    if (prevProps.activeTabId !== this.props.activeTabId && this.props.proceedBtnClick) {
      this.handleNavigation();
    }
    if (prevProps.transactionId !== this.props.transactionId) {
        this.setState({ showLoadingSpinner: true, quickEntryReleaseInfo: null, quickEntryReleaseComments: null, quickEntryServiceDateOverride: null })
        this.handleNavigation();
        this.initialAPICalls(this.props.transactionId)

    }
  }

  requestorToast = () =>{
    toast("Requestor verification email has been sent", {id: "reqPopUp", duration: 5000})
    this.props.requestorVerificationEmailSentReset()

  }

  setIsEscalated = (state) => {
    this.props.updateBillingPaneFields && this.props.updateBillingPaneFields(
      {
        transactionId: this.props.transactionId,
        patientDataid: this.props.patientDetails?.id,
        userID: global.userID,
        isEscalated: state
      });
  }

  userHasMadeChanged = () => {this.setState({ hasUserMadeAnyChanges: true })}

  /**
   * AC1/AC2/AC3 (revised, AB#34098 - dev direction after manual testing):
   * Quick Entry is the DEFAULT for any eligible transaction, not a
   * Completed-status-only special case. Classic Mode is a deliberate,
   * rare opt-out (matching master-demo-v6's own framing - an explicit
   * "Switch to Classic Mode" button, not a routing fallback) - it must
   * show only when the user (or a genuine failure path, once F1d #34102
   * builds one) explicitly requests it, never just because extraction
   * hasn't finished yet. Eligibility is therefore just the three flags:
   * IntakeIntelligence (AI extraction capability on), the per-facility DB
   * toggle (facilityConfiguration.intakeIntelligenceEnabled - the SAME
   * gate DataEntryDetailsBody.tsx checks for the classic Extract button),
   * and the SEPARATE QuickEntry flag (gates the new UI itself, decoupled
   * from AI-extraction rollout). RequestAnalysis.status is NOT part of
   * this gate anymore - getQuickEntryRows()/mapRequestTypePurposeToFieldGroupRow
   * already degrade gracefully to NeedsEntry when there's no analysis data
   * yet, so Quick Entry's shell renders correctly regardless of extraction
   * status; showing Failed/RetryExceeded/InProgress states visually inside
   * the row list is F1b-rois's (#34100) confidence-state domain.
   */
  isQuickEntryEligible = (): boolean => {
    return Boolean(this.props.featureFlags?.IntakeIntelligence)
      && Boolean(this.props.facilityConfiguration?.intakeIntelligenceEnabled)
      && Boolean(this.props.featureFlags?.QuickEntry)
      && !this.props.classicModeOverride;
  }

  /**
   * Only the Request Type/Purpose row is wired end-to-end in this Spec
   * (#34098 / F1a) - sibling Specs (F1b-rois #34100, F1c #34101, F3 #34099)
   * add their own rows against the FieldGroupRow contract in models/intake.ts.
   */
  /**
   * Row order mirrors master-demo-v6.html's own numbered sequence: Request
   * Type & Purpose, Service Date-From, Service Date-To, Records Requested,
   * Authorization Date, Request Date, Case Number, Clinic/Facility,
   * Sensitive Information. (Patient Info / Requestor Info / Provider-
   * Facility, the mockup's remaining 3 rows, are sibling-spec scope -
   * F1b-rois #34100 / F1c #34101 - not this Spec's contract.)
   */
  /**
   * Whether a row's prerequisite is currently satisfied. Direct user
   * feedback: the mockup's badge numbers are FIXED (never renumber based on
   * data state) - a row whose prerequisite isn't met yet stays in its fixed
   * slot, just non-interactive, rather than disappearing and shifting every
   * other row's number. getQuickEntryRows forces status to
   * EmptyNotRequired (tier 2 - excluded from outstanding/attention) for any
   * row this returns false for; renderQuickEntryRowContent renders it as a
   * disabled placeholder instead of the live control or Edit affordance.
   */
  isQuickEntryRowApplicable = (rowId: string): boolean => {
    const values = this.props.formState?.values ?? {};
    const requestType = values[FormConstants.REQUEST_TYPE];
    const requestPurpose = values[FormConstants.PURPOSE_TYPE];
    const facility = this.props.transactionDetails?.facility;

    switch (rowId) {
      case AUTHORIZATION_DATE_ROW_ID:
      case REQUEST_DATE_ROW_ID:
        // Mirrors the classic pane's own requestType != DISCLOSURE_ACCOUNTING gate.
        return requestType !== DISCLOSURE_ACCOUNTING;
      case CLINIC_RESPONSIBLE_ROW_ID:
        return Boolean(facility?.useClinics || facility?.useDepartments);
      case SERVICE_DATE_FROM_ROW_ID:
      case SERVICE_DATE_TO_ROW_ID:
      case RECORDS_REQUESTED_ROW_ID:
      case SENSITIVE_INFO_ROW_ID:
        // Based on the classic pane's own isVisibleSensitiveInfoToRelease
        // gate (transactionDetails.requestPurpose?.id) - but classic mode
        // can rely on that persisted value alone because by the time its
        // Details tab renders, Type/Purpose was already saved from an
        // earlier tab. Quick Entry is single-screen: a Purpose picked live
        // (or AI-extracted but not yet saved) only exists in the redux-form
        // values, so the persisted check alone would leave these rows
        // permanently non-applicable during a fresh manual entry. OR in the
        // live value so they unlock as soon as Purpose is set.
        return Boolean(this.props.transactionDetails?.requestPurpose?.id || requestPurpose) && requestType !== DISCLOSURE_ACCOUNTING;
      default:
        return true;
    }
  }

  getQuickEntryRows = (): readonly FieldGroupRow[] => {
    const values = this.props.formState?.values ?? {};
    const requestType = values[FormConstants.REQUEST_TYPE];
    const requestPurpose = values[FormConstants.PURPOSE_TYPE];
    const facility = this.props.transactionDetails?.facility;
    const useClinics = Boolean(facility?.useClinics);
    const dateRange = this.getQuickEntryServiceDateRange();
    const caseNumberRequired = requestType === DISABILITY_OR_SOCIAL_SECURITY || [3, 53].includes(requestType);

    // Fixed badge numbers matching master-demo-v6.html's own sequence -
    // never renumbered based on which rows are currently applicable (see
    // isQuickEntryRowApplicable's doc comment).
    const rows: FieldGroupRow[] = [
      mapRequestTypePurposeToFieldGroupRow(this.props.requestAnalysis?.data, 1, false, {
        requestType,
        requestPurpose,
        requestTypes: this.props.requestTypes,
      }),
      mapServiceDateFromToFieldGroupRow(2, dateRange),
      mapServiceDateToToFieldGroupRow(3, dateRange),
      mapRecordsRequestedToFieldGroupRow(4, this.getQuickEntryReleaseInfo()),
      mapAuthorizationDateToFieldGroupRow(5, requestPurpose, values[FormConstants.AUTHORIZATION_DATE]),
      mapRequestDateToFieldGroupRow(6, values[FormConstants.REQUEST_DATE]),
      mapCaseNumberToFieldGroupRow(7, caseNumberRequired, values[FormConstants.CASE_NUMBER]),
      mapClinicResponsibleToFieldGroupRow(8, useClinics, values[FormConstants.CLINIC_RESPONISBLE], this.props.discloseInstitutions),
      mapSensitiveInfoToFieldGroupRow(9, this.props.transactionDetails?.sensitiveInfo ?? []),
    ];

    return rows.map(row => this.isQuickEntryRowApplicable(row.id) ? row : {
      ...row,
      status: FieldGroupRowStatus.EmptyNotRequired,
      value: null,
      isAiPreSelected: false,
    });
  }

  /** Effective releaseInfo for Quick Entry: the optimistic override once the specialist has edited it this transaction, otherwise the server value. */
  getQuickEntryReleaseInfo = (): readonly Release[] => {
    return this.state.quickEntryReleaseInfo ?? this.props.transactionDetails?.releaseInfo ?? [];
  }

  getQuickEntryReleaseComments = (): string | undefined => {
    return this.state.quickEntryReleaseComments ?? this.props.transactionDetails?.requestComments;
  }

  getQuickEntryPatientDob = (): Date | undefined => {
    const dobValue = this.props.formState?.values?.[FormConstants.DOB];
    return dobValue ? new Date(dobValue) : undefined;
  }

  /**
   * Same infoToReleaseValidiation the classic pane's own validateReleaseInformation
   * runs before every save - e.g. "either a date range or All Dates" fires
   * whenever only one of From/To is set. Exposed separately from
   * persistQuickEntryReleaseInfo so the two Service Date rows can render the
   * same errMsg the classic pane would show inline, instead of silently no-
   * op'ing while the specialist is mid-way through entering a range.
   */
  validateQuickEntryReleaseInfo = (releaseInfo: readonly Release[]) => {
    return infoToReleaseValidiation(releaseInfo, this.getQuickEntryPatientDob());
  }

  /**
   * The From/To/AllDates the specialist is currently looking at - the
   * scratch override once touched this transaction, otherwise whatever's
   * already saved on releaseInfo. See the quickEntryServiceDateOverride
   * State doc comment for why this can't just be re-derived from
   * getReleaseDateRange(releaseInfo) on every render.
   */
  getQuickEntryServiceDateRange = (): { from?: Date; to?: Date; allDates: boolean } => {
    return this.state.quickEntryServiceDateOverride ?? getReleaseDateRange(this.getQuickEntryReleaseInfo());
  }

  /** Validates the CURRENT scratch range against releaseInfo, the same combination persistQuickEntryReleaseInfo is about to try to save - so the errMsg shown while typing matches what would block (or allow) the save. */
  getQuickEntryServiceDateValidation = () => {
    const { from, to, allDates } = this.getQuickEntryServiceDateRange();
    const updated = buildReleaseInfoWithDateRange(this.getQuickEntryReleaseInfo(), from, to, allDates);
    return this.validateQuickEntryReleaseInfo(updated);
  }

  /** Applies an updated releaseInfo/comments snapshot: optimistic local echo + the same API round-trip the classic pane already dispatches. */
  persistQuickEntryReleaseInfo = (updated: readonly Release[], comments?: string) => {
    const effectiveComments = comments ?? this.getQuickEntryReleaseComments();
    this.setState({ quickEntryReleaseInfo: updated, quickEntryReleaseComments: effectiveComments ?? null });

    // Mirrors classic mode's own validateReleaseInformation gate exactly -
    // an incomplete range (e.g. only From set, no To yet) must NOT reach the
    // API. Sending it anyway is what produced the informationToRelease
    // "Bad Request" (direct user report): the backend's From/To fields are
    // required together, and the AND-gated buildReleaseInfoWithDateRange
    // already drops both to undefined in that state - the missing piece was
    // this gate, not the payload shape.
    if (this.validateQuickEntryReleaseInfo(updated).display_error) {
      return;
    }

    const { from, to } = getReleaseDateRange(updated);
    this.props.saveInformationToRelease({
      organizationId: this.props.transactionDetails?.facility?.id ?? 0,
      requestBufferId: this.props.transactionDetails?.id ?? 0,
      releases: updated.filter(item => item.checked).map(item => item.id),
      from,
      to,
      requestComments: effectiveComments,
    });
  }

  onQuickEntryReleaseItemToggle = (itemId: number, checked: boolean) => {
    this.persistQuickEntryReleaseInfo(buildReleaseInfoWithItemToggle(this.getQuickEntryReleaseInfo(), itemId, checked));
  }

  onQuickEntryReleaseFreeTextChange = (text: string) => {
    this.persistQuickEntryReleaseInfo(this.getQuickEntryReleaseInfo(), text);
  }

  /** which selects which end of the shared range this row owns - the OTHER end is read fresh from current state and carried through unchanged. */
  onQuickEntryServiceDateChange = (which: "from" | "to", rawValue?: Date | string) => {
    let date: Date | undefined = typeof rawValue === "string" ? new Date(rawValue) : rawValue;
    if (date && isNaN(date.getTime())) {
      date = undefined;
    }

    const { from, to, allDates } = this.getQuickEntryServiceDateRange();
    const nextFrom = which === "from" ? date : from;
    const nextTo = which === "to" ? date : to;
    // Picking an explicit date implicitly turns off "All Dates" - mirrors InfoToRelease.tsx's changeFromDate/changeToDate.
    const nextAllDates = date ? false : allDates;

    // Scratch echo first (always retains exactly what was picked, even
    // half a range) - see the quickEntryServiceDateOverride doc comment.
    this.setState({ quickEntryServiceDateOverride: { from: nextFrom, to: nextTo, allDates: nextAllDates } });

    this.persistQuickEntryReleaseInfo(buildReleaseInfoWithDateRange(this.getQuickEntryReleaseInfo(), nextFrom, nextTo, nextAllDates));
  }

  /**
   * AC9/AC10 (revised): N (outstanding rows) drives the morphing action
   * button, which lives in the Quick Entry panel's own footer
   * (QuickEntryActionFooter.tsx, mounted via QuickEntryFieldGroupList's
   * footer prop) per the mockup's .action-footer - not under the row list
   * itself, and not DataEntryDetailsLeftPane.tsx. Uses the
   * same isFieldGroupRowOutstanding definition QuickEntryFieldGroupList
   * itself would use, so the two never drift.
   */
  getQuickEntryOutstandingCount = (): number => {
    return this.getQuickEntryRows().filter(row => isFieldGroupRowOutstanding(row, EMPTY_VERIFIED_ROW_IDS)).length;
  }

  onClickQuickEntryAction = () => {
    const outstanding = this.getQuickEntryRows().find(row => isFieldGroupRowOutstanding(row, EMPTY_VERIFIED_ROW_IDS));
    if (outstanding) {
      this.onJumpToQuickEntryRow(outstanding.id);
    } else {
      this.onSubmitQuickEntry();
    }
  }

  /**
   * AC11: mounts the SAME RequestTypePurposeField component the classic
   * RightPane Details tab uses for the Request Type/Purpose row, so both
   * views write into - and, for this component's own value display, read
   * from - the same DATA_ENTRY_FIELDS_FORM redux-form instance via the
   * shared writeFieldToForm helper. Sibling specs' rows fall through to
   * QuickEntryFieldGroupList's generic label/value display (this returns
   * undefined for any row id other than the Request Type/Purpose one).
   */
  /**
   * master-demo-v6.html shows a Confirmed row as plain read-only value text
   * with an "Edit" button in the action slot; a NeedsEntry/LowConfidence
   * row shows its live editable control directly with no separate Edit
   * button (it's already "in edit mode"). This exits edit mode
   * automatically once the field actually reports a new value, rather than
   * requiring a separate explicit "confirm" step.
   */
  onEditQuickEntryRow = (rowId: string) => {
    this.setState(prev => ({ quickEntryEditingRowIds: new Set(prev.quickEntryEditingRowIds).add(rowId) }));
  }

  onQuickEntryFieldConfirmed = (rowId: string) => {
    this.setState(prev => {
      if (!prev.quickEntryEditingRowIds.has(rowId)) {
        return null;
      }
      const next = new Set(prev.quickEntryEditingRowIds);
      next.delete(rowId);
      return { quickEntryEditingRowIds: next };
    });
  }

  renderQuickEntryRowContent = (row: FieldGroupRow) => {
    const values = this.props.formState?.values ?? {};
    const requestType = values[FormConstants.REQUEST_TYPE];
    const facility = this.props.transactionDetails?.facility;

    // Row badge numbers are fixed (master-demo-v6.html's own sequence never
    // shifts) - direct user feedback after comparing against the actual
    // demo: rows whose prerequisite isn't met yet (e.g. Purpose not picked,
    // Disclosure Accounting type, no Clinic/Department config) stay visible
    // in their fixed slot rather than being hidden/renumbered; they're just
    // non-interactive until the prerequisite is satisfied. getQuickEntryRows
    // already forces status to EmptyNotRequired for these so they're
    // correctly excluded from the outstanding/attention counts.
    if (!this.isQuickEntryRowApplicable(row.id)) {
      return (
        <div className="qe-row__body">
          <div className="qe-row__label">{row.label}</div>
          <div className="qe-row__value qe-row__value--disabled">Not applicable yet</div>
        </div>
      );
    }

    const isEditing = row.status !== FieldGroupRowStatus.Confirmed || this.state.quickEntryEditingRowIds.has(row.id);

    if (!isEditing) {
      switch (row.id) {
        case REQUEST_TYPE_PURPOSE_ROW_ID:
        case AUTHORIZATION_DATE_ROW_ID:
        case REQUEST_DATE_ROW_ID:
        case CASE_NUMBER_ROW_ID:
        case CLINIC_RESPONSIBLE_ROW_ID:
        case SERVICE_DATE_FROM_ROW_ID:
        case SERVICE_DATE_TO_ROW_ID:
        case RECORDS_REQUESTED_ROW_ID:
        case SENSITIVE_INFO_ROW_ID:
          return (
            <>
              <div className="qe-row__body">
                <div className="qe-row__label">{row.label}</div>
                <div className="qe-row__value">
                  <span className="qe-row__value-part">{row.value}</span>
                  {row.isAiPreSelected ? <span className="qe-chip--ai">AI pre-selected</span> : null}
                </div>
              </div>
              <div className="qe-row__action">
                <button type="button" className="qe-btn" onClick={() => this.onEditQuickEntryRow(row.id)}>Edit</button>
              </div>
            </>
          );
        default:
          return undefined;
      }
    }

    let field: React.ReactNode;
    switch (row.id) {
      case REQUEST_TYPE_PURPOSE_ROW_ID:
        field = (
          <RequestTypePurposeField
            requestTypes={this.props.requestTypes}
            value={requestType}
            purposeValue={values[FormConstants.PURPOSE_TYPE]}
            isAiPreSelected={row.isAiPreSelected}
            dispatch={this.props.dispatch!}
            onRequestPurposeChange={() => this.onQuickEntryFieldConfirmed(row.id)}
          />
        );
        break;
      case AUTHORIZATION_DATE_ROW_ID:
        field = (
          <AuthorizationDateField
            value={values[FormConstants.AUTHORIZATION_DATE]}
            requestPurposeId={values[FormConstants.PURPOSE_TYPE]}
            visible
            dispatch={this.props.dispatch!}
            onAuthorizationDateChange={(value) => { if (value) { this.onQuickEntryFieldConfirmed(row.id); } }}
          />
        );
        break;
      case REQUEST_DATE_ROW_ID:
        field = (
          <RequestDateField
            value={values[FormConstants.REQUEST_DATE]}
            visible
            dispatch={this.props.dispatch!}
            onRequestDateChange={(value) => { if (value) { this.onQuickEntryFieldConfirmed(row.id); } }}
          />
        );
        break;
      case CASE_NUMBER_ROW_ID: {
        const caseNumberRequired = requestType === DISABILITY_OR_SOCIAL_SECURITY || [3, 53].includes(requestType);
        field = (
          <CaseNumberField
            value={values[FormConstants.CASE_NUMBER]}
            required={caseNumberRequired}
            dispatch={this.props.dispatch!}
            onCaseNumberBlur={(value) => { if (value) { this.onQuickEntryFieldConfirmed(row.id); } }}
          />
        );
        break;
      }
      case CLINIC_RESPONSIBLE_ROW_ID:
        field = (
          <ClinicResponsibleField
            value={values[FormConstants.CLINIC_RESPONISBLE]}
            useClinics={Boolean(facility?.useClinics)}
            useDepartments={Boolean(facility?.useDepartments)}
            discloseInstitutions={this.props.discloseInstitutions}
            dispatch={this.props.dispatch!}
            onClinicResponsibleChange={() => this.onQuickEntryFieldConfirmed(row.id)}
          />
        );
        break;
      case SERVICE_DATE_FROM_ROW_ID: {
        // No onQuickEntryFieldConfirmed wiring here unlike the simpler
        // fields - this row's status is driven by the lifted
        // quickEntryReleaseInfo (server-confirmed via saveInformationToRelease's
        // round-trip), not a local form value, so it naturally flips to
        // Confirmed once the checked date resolves rather than needing an
        // explicit "exit edit mode" trigger on every change.
        // No "All Dates" affordance here (per direct user feedback) - the
        // mockup's row list has no such control, so Quick Entry requires an
        // explicit range; a specialist needing an open-ended "all dates"
        // request uses Classic Mode for that transaction. Picking a real
        // date still clears any allDates flag inherited from elsewhere
        // (AI extraction / a prior Classic Mode edit) via
        // onQuickEntryServiceDateChange, so this never becomes a dead end.
        const { from, to } = this.getQuickEntryServiceDateRange();
        const fromValidation = this.getQuickEntryServiceDateValidation();
        field = (
          <DateField
            label="Service Date - From"
            placeholder="mm/dd/yyyy"
            errMsg={fromValidation.errors.from || fromValidation.errors.items}
            value={from}
            minDate={DEFAULT_MIN_DATE}
            maxDate={to ?? new Date()}
            onChange={(value) => this.onQuickEntryServiceDateChange("from", value)}
          />
        );
        break;
      }
      case SERVICE_DATE_TO_ROW_ID: {
        const { from, to } = this.getQuickEntryServiceDateRange();
        const toValidation = this.getQuickEntryServiceDateValidation();
        field = (
          <DateField
            label="Service Date - To"
            placeholder="mm/dd/yyyy"
            errMsg={toValidation.errors.to || toValidation.errors.items}
            value={to}
            minDate={from ?? DEFAULT_MIN_DATE}
            maxDate={new Date()}
            onChange={(value) => this.onQuickEntryServiceDateChange("to", value)}
          />
        );
        break;
      }
      case RECORDS_REQUESTED_ROW_ID: {
        const releaseInfo = this.getQuickEntryReleaseInfo();
        const checkboxItems: CheckboxItem[] = releaseInfo.map(item => ({
          id: item.id,
          state: item.checked ? SensitiveInfoRelease.Authorized : SensitiveInfoRelease.NotMentioned,
          label: item.name,
        }));
        field = (
          <CheckboxList
            items={checkboxItems}
            checkboxHeader="RETRIEVE"
            labelHeaders={["RECORD TYPE"]}
            onChange={(itemId, checked) => this.onQuickEntryReleaseItemToggle(itemId, checked)}
            className="checkboxSection"
            freeText={this.getQuickEntryReleaseComments()}
            hasFreeText={(item) => item?.id === 31}
            onChangeFreeText={(text) => this.onQuickEntryReleaseFreeTextChange(text)}
            freeTextMaxLen={2000}
            allowUncheck
          />
        );
        break;
      }
      case SENSITIVE_INFO_ROW_ID:
        // Same reasoning as RECORDS_REQUESTED_ROW_ID above - status is
        // server-confirmed via transactionDetails.sensitiveInfo refresh
        // after saveAndUpdateSensitiveInfo's round-trip, not a local form
        // value, so no explicit onQuickEntryFieldConfirmed wiring is needed.
        field = (
          <SensitiveInfoField
            data={this.props.transactionDetails?.sensitiveInfo ?? []}
            transactionId={this.props.transactionId}
            dispatch={this.props.dispatch!}
            visible
            saveAndUpdateSensitiveInfo={this.props.saveAndUpdateSensitiveInfo}
          />
        );
        break;
      default:
        return undefined;
    }

    return (
      <>
        <div className="qe-row__body">
          <div className="qe-row__label">{row.label}</div>
          <div className="qe-row__value">{field}</div>
        </div>
        <div className="qe-row__action" />
      </>
    );
  }

  /**
   * AC9: scrolls the outstanding row into view when the morphing action
   * button reads "Next Action Required (N)". Mirrors the existing
   * scrollIntoView pattern in DataEntryDetailsRightPane.tsx (its own
   * `scrollTo` effect), just keyed off data-row-id instead of a DOM id since
   * QuickEntryFieldGroupList's rows aren't individually id'd elements.
   */
  onJumpToQuickEntryRow = (rowId: string) => {
    document.querySelector(`[data-row-id="${rowId}"]`)?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  /**
   * AC6 (Spec #34100 / F1b-rois, D2 per PRD 2026-07-01): reveal a clicked field's source region
   * by SCROLLING the PdfViewer to the source page, reusing the v1.1a setPageNumber seam. Permanent
   * region highlights are explicitly out of scope for v1.1b — this navigates only. The grounding's
   * bounding box stays in the model/DTO (contract data) but does not drive any UI overlay.
   */
  onRevealQuickEntryGrounding = (grounding: FieldGrounding) => {
    this.props.setPageNumber(grounding.pageNumber, this.props.currentFile);
  }

  /**
   * AC7 (no-source variant): a field with no grounding shows an informational toast and does not
   * scroll — the v1.1a fallback when FieldGroundings is empty/absent (locatedGate OFF).
   */
  onQuickEntryGroundingUnavailable = () => {
    toast("No source location is available for this field.");
  }

  /**
   * AC10: the real Confirm-All submission - Confirm-All gating, transaction
   * creation, and billing handoff - is F1d's (#34102) scope, not built yet.
   * This is an honest placeholder so the button gives clear feedback during
   * testing instead of silently doing nothing; replace when F1d lands.
   */
  onSubmitQuickEntry = () => {
    toast("Confirm All isn't wired up yet - pending F1d (#34102).");
  }

  render() {
    const { selectedHealthOrganizationDetails, selectedFacilityDetails, transactionId } = this.props
    const homeText = getRoutePathName(selectedHealthOrganizationDetails, selectedFacilityDetails)
    const storedWidth = localStorage.getItem('centerPanelWidth') || '50%';

    const docAIProcessID = this.props.transactionDetails?.docAIProcessID;
    const authorizedEntities: {readonly [key in EntityTypeId]?: boolean} = {
      [DRUG]: this.props.transactionDetails?.sensitiveInfo.some(inf => inf.id == SensitiveInfoType.SubstanceAbuse && inf.stateID == SensitiveInfoRelease.Authorized),
      [STD]: this.props.transactionDetails?.sensitiveInfo.some(inf => inf.id == SensitiveInfoType.Std && inf.stateID == SensitiveInfoRelease.Authorized),
      [PSYC_MHLT]: this.props.transactionDetails?.sensitiveInfo.some(inf => inf.id == SensitiveInfoType.MentalHealth && inf.stateID == SensitiveInfoRelease.Authorized),
      [HIV]: this.props.transactionDetails?.sensitiveInfo.some(inf => inf.id == SensitiveInfoType.HivAids && inf.stateID == SensitiveInfoRelease.Authorized),
      [HPV]: this.props.transactionDetails?.sensitiveInfo.some(inf => inf.id == SensitiveInfoType.Std && inf.stateID == SensitiveInfoRelease.Authorized),
    };

    homeText.push("Data Entry")
    return (
      <div>
        {this.state.showLoadingSpinner || !this.props.transactionDetails ? <LoadingSpinner /> :
          <Container fluid className="app-container-custom-style" style={{"maxHeight": "100vh", "overflow": "hidden"}}>
            <div className="landing-page-header pb-0">
              <Header name="Data Entry" homeText={homeText} getNextQATransaction={getNextQATransaction} />
            </div>
            <Row className='mr-0 data-entry-wrapper'>
              <div
                id="leftPanel"
                className="pr-0 h-100 d-flex flex-column"
                style={{
                  "position": "relative",
                  "overflow": "hidden",
                  "minWidth": "15%",
                  "maxWidth": "50%",
                  "width": localStorage.getItem("leftWidth") ?? "25%",
                  "resize": "horizontal"
                }}
                onMouseUp={(_event) => this.savePanelSizes()}
              >
                <DataEntryDetailsLeftPane
                  hideFooter={this.isQuickEntryEligible()}
                  transactionNotes={this.props.transactionNotes}
                  transactionDetails={this.props.transactionDetails}
                  requestorDetails={this.props.requestorDetails}
                  transactionId={transactionId}
                  patientDetails={this.props.patientDetails}
                  userTasks={this.props.userTasks}
                  userTaskComments={this.props.userTaskComments}
                  resetForm={this.props.resetForm}
                  setEscalation={this.setIsEscalated}
                  assessmentResult={this.props.assessmentResult}
                  authorizedEntities={authorizedEntities}
                  qaErrors={this.props.qaErrors}
                  qaIssues={this.props.QAIssues}
                  setPageNumber={this.props.setPageNumber}
                  setCurrentFileType={this.props.setCurrentFileType}
                  currentFileType = {this.props.currentFileType}
                  pageNumber = {this.props.pageNumber}
                  currentFile = {this.props.currentFile}
                  auditTrail = {this.props.auditTrail}
                  documentsList={this.props.documentsList}
                />
              </div>
              <div className='pr-0 d-flex flex-column h-100 flex-grow-1 flex-shrink-1' style={{"flexBasis": "auto", "position": "relative"}}>
                <Row className='mx-0 w-100'>
                  <Col lg={12} className='pr-0 pl-lg-0'>
                    {this.isQuickEntryEligible() ? (
                      this.renderQuickEntryStepTabs()
                    ) : (
                      <div className="breadcrumb-wrapper">
                        {this.renderTabItems()}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className='request-content-wrapper mr-0' style={{ zIndex: 2 }}>
                  <div
                    id="centerPanel"
                    className='request-pdf-wrapper'
                    style={{
                      position: "relative",
                      minWidth: "740px",
                      maxWidth: "85%",
                      width: localStorage.getItem("centerWidth") ?? "50%",
                      resize: "horizontal",
                    }}
                    onMouseUp={(_event) => this.savePanelSizes()}
                  >
                    <DataEntryDetailsBody
                      documentsList={this.props.documentsList}
                      uploadMultipleDocuments={this.props.uploadMultipleDocuments}
                      transactionId={transactionId}
                      transactionDetails={this.props.transactionDetails}
                      activeTabId={this.props.activeTabId}
                      getDocumentById={this.props.getDocumentById}
                      getTransactionDocuments={this.props.getTransactionDocuments}
                      updateDocument={this.props.updateDocument}
                      documentSources={this.props.documentSources}
                      deleteDocument={this.props.deleteDocument}
                      deleteAuxDocument={this.props.deleteAuxDocument}
                      deleteDocumentSuccess={this.props.deleteDocumentSuccess}
                      hasUserMadeAnyChanges={this.state.hasUserMadeAnyChanges}
                      userHasMadeChanged={this.userHasMadeChanged}
                      docAIProcessID={docAIProcessID}
                      getTransactionDocumentsAPIStatus={this.props.getTransactionDocumentsAPIStatus}
                      setPageNumber={this.props.setPageNumber}
                      setCurrentFileType={this.props.setCurrentFileType}
                      currentFileType = {this.props.currentFileType}
                      pageNumber = {this.props.pageNumber}
                      currentFile = {this.props.currentFile}
                      assessmentResult={this.props.assessmentResult}
                      authorizedEntities={authorizedEntities}
                    />
                  </div>
                  <div className='pr-0 data-entry-form-wrapper flex-grow-1 flex-shrink-1' style={{"flexBasis": "auto", "position": "relative"}}>
                    {this.isQuickEntryEligible() ?
                      <QuickEntryFieldGroupList
                        rows={this.getQuickEntryRows()}
                        renderRowContent={this.renderQuickEntryRowContent}
                        renderRowAdornment={(row) => (
                          <QuickEntryFieldConfidence
                            row={row}
                            status={this.props.requestAnalysis?.status}
                            confidence={this.props.requestAnalysis?.confidence}
                            fieldGroundings={this.props.requestAnalysis?.fieldGroundings}
                            onRevealGrounding={this.onRevealQuickEntryGrounding}
                            onNoSource={this.onQuickEntryGroundingUnavailable}
                          />
                        )}
                        footer={
                          <QuickEntryActionFooter
                            transactionId={this.props.transactionId}
                            organizationId={this.props.transactionDetails?.facility?.id}
                            requestContext={this.props.requestContext}
                            resetForm={() => this.props.resetForm()}
                            resetDataEntryState={() => this.props.resetDataEntryState()}
                            healthSystemDataEntryCount={this.props.healthSystemDataEntryCount}
                            actionCount={this.getQuickEntryOutstandingCount()}
                            onAction={this.onClickQuickEntryAction}
                          />
                        }
                      />
                      :
                      <DataEntryDetailsRightPane
                        onChangeDataEntryTab={this.props.onChangeDataEntryTab}
                        activeTabId={this.props.activeTabId}
                        proceedBtnClick={this.props.proceedBtnClick}
                        retrieveProtocol={this.props.retrieveProtocol}
                        transactionDetails={this.props.transactionDetails}
                        additionalChargeRecords={this.props.additionalChargeRecords}
                        getFacilityFeeSchedules={this.props.getFacilityFeeSchedules}
                        getFacilityReleaseMethods={this.props.getFacilityReleaseMethods}
                        getFacilityShippingServices={this.props.getFacilityShippingServices}
                        userHasMadeChanged={this.userHasMadeChanged}
                      />
                    }
                  </div>
                </Row>
              </div>
            </Row>
          </Container>
        }
        {this.props.isRequestorVerificationEmailSent? this.requestorToast() : null}

        <Toaster toastOptions={{
                  className: 'toast-notification',
                }}
         position="top-right" />
      </div>
    );
  }
}

function mapStateToProps(state: RootState) {
  //These two lines assume that the landingPageState.getHealthOrganizationsSearch will contain the entire health org list that the user will have access to.
  //If we move to a back end paging/searching system (paging and searching controlled by the db stored procedure) this will have to change
  //and it will require either the transaction search receiving the Health Org Id, or a way to search health orgs/facilities using only the facility id

  // const healthOrgDetails = state.landingPageState.selectedHealthOrganizationDetails ??
  //   state.landingPageState.getHealthOrganizationsSearch?.filter(h => h.healthSystem.facilities
  //     .some(f => f.facility.id == state.landingPageState.selectedFacilityDetails?.facility.id))[0]

  // const facilityDetails = state.landingPageState.selectedFacilityDetails?.facility?.name
  //   ? state.landingPageState.selectedFacilityDetails
  //   : healthOrgDetails?.facilityCounts?.find(f => f.facility.id === state.landingPageState.selectedFacilityDetails.facility.id);

  return {
    activeTabId: state.dataEntryState.activeTabId,
    proceedBtnClick: state.dataEntryState.proceedBtnClick,
    selectedHealthOrganizationDetails: state.landingPageState.selectedHealthOrganizationDetails,
    selectedFacilityDetails: state.landingPageState.selectedFacilityDetails,
    transactionId: state.landingPageState.transactionId,
    transactionIDAttributes: state.dataEntryState.transactionIDAttributes,
    patientDetails: state.dataEntryState.leftPanePatientDetailsAttributes,
    transactionNotes: state.dataEntryState.transactionNotes,
    documentsList: state.dataEntryState.documentsList,
    documentSources: state.dataEntryState.documentSources,
    retrieveProtocol: state.dataEntryState.retrieveProtocol,
    formState: state.form && state.form[FormConstants.DATA_ENTRY_FIELDS_FORM],
    discloseInstitutions: state.dataEntryState.discloseInstitutions,
    transactionDetails: state.dataEntryState.transactionDetails,
    userTasks: state.dataEntryState.userTasks,
    userTaskComments: state.dataEntryState.userTaskComments,
    feeSchedules: state.dataEntryState.feeSchedules,
    additionalChargeRecords: state.dataEntryState.additionalChargeRecords,
    isRequestorVerificationEmailSent: state.dataEntryState.requestorVerificationEmailSent,
    requestorVerificationEmailPopupTriggered: state.dataEntryState.requestorVerificationEmailPopupTriggered,
    requestorDetails: state.dataEntryState.requestorDetails,
    deleteDocumentSuccess: state.dataEntryState.deleteDocumentAPISuccess,
    intiaTxlSagaCallCount: state.dataEntryState.intiaTxlSagaCallCount,
    requestContext: state.landingPageState.requestContext,
    uploadDocumentSuccess: state.dataEntryState.uploadDocumentSuccess,
    assessmentResult: state.dataEntryState.assessmentResult,
    qaErrors: state.dataEntryState.getQAErrors,
    QAIssues: state.dataEntryState.getQAIssues,
    featureFlags: state.loginState.featureFlags,
    getTransactionDocumentsAPIStatus: state.dataEntryState.getTransactionDocumentsAPIStatus,
    currentFileType: state.dataEntryState.currentFileType,
    pageNumber: state.dataEntryState.pageNumber,
    currentFile: state.dataEntryState.currentFile,
    auditTrail: state.dataEntryState.auditTrail,
    requestAnalysis: state.dataEntryState.requestAnalysis,
    // Same selector DataEntryDetailsBody.tsx already uses for the classic
    // Extract button's facility-level gate (Tech Lead note, AB#34098).
    facilityConfiguration: state.dataEntryState.facilityConfiguration,
    // F1d #34102 owns the real Classic-Mode exit dialog/state; defaults to
    // false until that lands.
    classicModeOverride: Boolean((state.dataEntryState as any).classicModeOverride),
    healthSystemDataEntryCount: state.landingPageState.selectedFacilityDetails?.transactionCounts?.dataEntry,
    // AC11 (F1a): mirrors DataEntryDetailsRightPane's own
    // `requestTypes: state.dataEntryState.requestTypes` binding, needed to
    // mount the shared RequestTypePurposeField inside the Quick Entry row.
    requestTypes: state.dataEntryState.requestTypes,
  };
}

function mapDispatchToProps(dispatch: Function): any {
  return {
    // AC11 (F1a): raw dispatch passthrough, needed because
    // RequestTypePurposeField's contract takes `dispatch: Function` directly
    // (it calls writeFieldToForm itself, same as DataEntryDetailsRightPane
    // does when it renders this same component).
    dispatch,
    onChangeDataEntryTab: (data: number, tabClick: boolean) =>
      dispatch(onChangeDataEntryTab(data, tabClick)),
    resetForm: () => dispatch(reset(FormConstants.DATA_ENTRY_FIELDS_FORM)),
    saveInformationToRelease: (data: ReleaseInfoUpdate) => dispatch(updateInformationToReleaseActionCreator(data)),
    saveAndUpdateSensitiveInfo: (data: SensitiveInfoUpdateAPI) => dispatch(updateSensitiveInfoActionCreator(data)),
    getTransactionAttributes: (transactionId: string) =>
      dispatch(getTransactionAttributesActionCreator(transactionId)),
    getDocumentById: (documentId: string, auditOnShowDoc: boolean) =>
      dispatch(getDocumentByIdActionCreator(documentId, auditOnShowDoc)),
    getFacilityFeeSchedules: (organizationId: number, transactionId: string) => dispatch(getFeeScheduleData(organizationId, transactionId, false)),
    getFacilityShippingServices: (facilityId: number) => dispatch(getShippingServicesData(facilityId)),
    getFacilityReleaseMethods: (facilityId: number, transactionId: string) => dispatch(getReleaseMethodOptionsData(facilityId, transactionId)),

    getTransactionNotesRequest: (transactionId: string) =>
      dispatch(getTransactionNotesRequest(transactionId)),
    getAdditionalChargeType: (facilityId: number) =>
      dispatch(getAdditionalChargeType(facilityId)),
    getAdditionalChargeRecords: (transactionId: string) =>
      dispatch(getAdditionalChargeRecordsCreator(transactionId)),
    getTransactionDocuments: (transactionId: string) =>
      dispatch(getTransactionDocuments(transactionId)),
    getRejectOptions: (facilityId: number) => dispatch(getRejectOptions(facilityId)),
    getTransactionNoteTypes: (facilityId: number) => dispatch(getTransactionNoteTypes(facilityId)),
    uploadMultipleDocuments: (data: DocumentUploadRequest) => dispatch(uploadMultipleDocumentsActionCreator(data)),
    resetDataEntryState: () => dispatch(resetDataEntryState()),
    getDocumentSources: (data: any) => dispatch(getDoucmentSourcesActionCreator(data)),
    deleteAuxDocument: (transactionId: string) => dispatch(deleteDocumentActionCreator("AUX", transactionId)),
    deleteIntDocument: (transactionId: string) => dispatch(deleteDocumentActionCreator("INT", transactionId)),
    deleteDocument: (documentId: any) => dispatch(deleteDocumentActionCreator("MED", documentId)),
    getRetrieveProtocol: (data: any) => dispatch(getRetrieveProtocolActionCreator(data)),
    transactionCancellationReasons: (facilityId: number) => dispatch(getCancellationReasons(facilityId)),
    getSelectedPHICodes: (transactionId: string) =>
      dispatch(getSelectedPHICodesActionCreator(transactionId)),
    getPHICodesRequest: (facilityId: number) => dispatch(getPHICodesRequest(facilityId)),
    getUserGroups: (facilityId: number) => dispatch(getUserGroupsActionCreator(facilityId)),
    getDisclosureReasons: (facilityId: number) => dispatch(getDisclosureReasonActionCreator(facilityId)),
    stopSubmit: (validations: any) => dispatch(stopSubmit(FormConstants.DATA_ENTRY_FIELDS_FORM, validations)),
    updateFormSyncErrors: (data: any) => dispatch(updateFormSyncErrorsActionCreator(data)),
    getUserTasks: (data: any) => dispatch(getUserTasksActionCreator(data)),
    submitForm: () => dispatch(submit(FormConstants.DATA_ENTRY_FIELDS_FORM)),
    touch: (fields: any) => dispatch(touch(FormConstants.DATA_ENTRY_FIELDS_FORM, fields)),
    getRequestsAndPurposes: (healthSystemId: number) => dispatch(getRequestTypesAndPurposesRequest(healthSystemId)),
    getFacilityDiscloseInstitutionsRequest: (facilityId: number) => dispatch(getFacilityDiscloseInstitutionsRequest(facilityId)),
    requestorVerificationEmailSent: () => dispatch(requestorVerificationEmailSent()),
    requestorVerificationEmailSentReset: () => dispatch(RequestorVerificationEmailSentReset()),
    setLastUsedRequestorInfo: (data: any) => dispatch(setLastUsedRequestorInfo(data)),
    patchRequestorComplete: (data: string) => dispatch(requestorCompleteActionCreator(data)),
    patchBillingComplete: (data: string) => dispatch(billingCompleteActionCreator(data)),
    postCancellationReasonsDispatch: (transactionId: string, id: any, cancelReasonText: string) => dispatch(postCancellationReasonsActionCreators(transactionId, id, cancelReasonText)),
    getFacilityAdditionalFieldsActionCreator: (data) => dispatch(getFacilityAdditionalFieldsActionCreator(data)),
    transactionWaitAndHoldReasons: (data) => dispatch(getWaitAndHoldReasons(data)),
    getOutboundTemplateRequest: () => dispatch(getOutboundTemplateRequest()),
    getAssessmentResults: (transactionId: string) => dispatch(getAssessmentResultsActionCreator(transactionId)),
    getReviewEntities: (transactionId: string) => dispatch(getReviewEntitiesActionCreator(transactionId)),
    getEntityTypes: () => dispatch(getSensitivityTypesActionCreator()),
    getQAErrors:() => dispatch(getQAErrorsActionCreator()),
    getQAIssues: (transactionId: string) => dispatch(getQAIssuesActionCreator(transactionId)),
    getQAPDIssues:(transactionId: string) => dispatch(getQAPDIssuesActionCreator(transactionId)),
    updateBillingPaneFields: (data: any, updateData) => {return dispatch(updateBillingPaneFields(data, updateData))},
    getAIFeedback: () => dispatch(getAIFeedbackActionCreator()),
    getAuditUsers: (transactionId: string) => dispatch(getAuditUsersActionCreator(transactionId)),
    getCertificationTypes: () => dispatch(getCertificationTypesAction()),
    setPageNumber: (pageNumber: number, fileDesc: string) => dispatch(setPDFPageNumberActionCreator(pageNumber, fileDesc)),
    setCurrentFileType: (fileType) => dispatch(setCurrentFileTypeActionCreator(fileType)),
    updateDocument: (data: any) => dispatch(updateDocumentActionCreator(data)),
    getFacilityConfiguration: (facilityId: number) => dispatch(getFacilityConfigurationsActionCreator(facilityId)),
    getIntakeIntelligence: (organizationId: number, requestBufferId: number) =>
        dispatch(getIntakeIntelligenceActionCreator(organizationId, requestBufferId)),
    getQAFeatureFlagsRequest: () => dispatch(getQAFeatureFlagsRequestActionCreator()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DataEntryDetails);
